import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { CommissionSettings } from '../models/admin.models';
import { ApiResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AdminCommissionsService {
  private baseUrl = `${environment.apiBaseUrl}/admin/settings/commission`;

  constructor(private http: HttpClient) { }

  getCommission(): Observable<CommissionSettings> {
    return this.http.get<ApiResponse<CommissionSettings>>(this.baseUrl).pipe(
      map(res => res.data)
    );
  }

  updateCommission(data: CommissionSettings): Observable<CommissionSettings> {
    return this.http.put<ApiResponse<CommissionSettings>>(this.baseUrl, data).pipe(
      map(res => res.data)
    );
  }
}
